import React, { useState, useEffect } from 'react';
import { ReactComponent as SortIcon } from '../../../assets/icons/sort.svg';
import './styles.scss';
import {
  Button,
  DateRangeSelector,
  Dropdown,
  DropdownItem,
  DropdownList,
  ENUM_DATE_RANGE
} from '@cokitchen/cokitchen-components';
import { ArrowLeftIcon } from 'cokitchen-icons';
import { apiService } from 'utils/api';
import NoticeCard, { NoticeDataType } from './notice-card';
import { SelectionRangeType } from 'components/base/calendar';
import NoticeBoardModal from 'components/cs/pending-tasks/notice-board';
import { useNavigate } from 'react-router-dom';

const NoticeBoard = () => {
  const [data, setData] = useState([] as NoticeDataType[]);
  const [loading, setLoading] = useState(false);

  const [showNoticeModal, setShowNoticeModal] = useState(false);

  const navigate = useNavigate();
  const [selectionRange, setSelectionRange] = useState({} as SelectionRangeType);

  const [filter, setFilter] = useState('Active');

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiService.post('kitchen/get-team-notification', {
        baseUrl: 'https://order-api.getfoodcourt.com/v1/',
        data: { start_date: selectionRange.startDate, end_date: selectionRange.endDate }
      });
      setData(res.data.data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [selectionRange]);
  const options = [
    {
      name: 'Active',
      onClick: () => {
        setFilter('Active');
      }
    },
    {
      name: 'Inactive',
      onClick: () => {
        setFilter('Inactive');
      }
    },
    {
      name: 'Draft',
      onClick: () => {
        setFilter('Draft');
      }
    }
  ];

  const newNotice = () => {
    setShowNoticeModal(true);
  };
  const goBack = () => {
    navigate('/settings');
  };

  const toggleNoticeBoard = (refetchData?: boolean) => {
    if (refetchData) fetchData();
    setShowNoticeModal(!showNoticeModal);
  };

  return (
    <div>
      <div className='flex justify-start items-center gap-3 mb-[28px]'>
        <div className='p-2 bg-[#F4F1F1] text-primary cursor-pointer rounded-full' onClick={goBack}>
          <ArrowLeftIcon color='#E60A2B' />
        </div>
        <p className='text-sm font-medium'>Return to settings</p>
      </div>

      <div className='flex justify-between items-center mb-[34px]'>
        <div className=''>
          <p className='text-[20px] font-semibold'>Notice board</p>
          <p className='text-[#595959]'>Need to pass across a message to the team, do it here</p>
        </div>
        <Button className='w-44' color='primary' variant='block' small onClick={newNotice}>
          New notice
        </Button>
      </div>
      <div className='flex justify-start gap-5  mb-4'>
        <Dropdown
          content={
            <div className=''>
              <button className='border border-[#EAEBEB] bg-white rounded mb-4 min-w-[120px] py-[5px] px-2 '>
                <p className='flex justify-start items-center gap-3 pl-2 text-sm'>
                  <SortIcon /> {filter}
                </p>
              </button>
            </div>
          }>
          <DropdownList>
            {options.map(({ onClick, name }, index) => (
              <DropdownItem
                key={index}
                onClick={onClick}
                className='text-sm font-light  hover:bg-gray-400 cursor-pointer'
                buttonClassName='py-2'>
                <div className=''>{name}</div>
              </DropdownItem>
            ))}
          </DropdownList>
        </Dropdown>
        <DateRangeSelector
          showTime
          defaultRange={ENUM_DATE_RANGE.ALL}
          className='h-8 '
          onChange={(v) => setSelectionRange({ ...v.date })}
        />
      </div>
      <div className={`grid md:grid-cols-2 lg:grid-cols-3' gap-4`}>
        {loading ? (
          <p>Loading</p>
        ) : data.length === 0 ? (
          <p>No notice to display</p>
        ) : (
          data.map((item, index) => <NoticeCard key={index} data={item} />)
        )}
      </div>

      <NoticeBoardModal show={showNoticeModal} onClose={toggleNoticeBoard} />
    </div>
  );
};

export default NoticeBoard;
